import React, { createContext, useContext, useState, useCallback } from "react";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("jv-lang") || "en");

  const toggle = useCallback(() => {
    setLang((prev) => {
      const next = prev === "en" ? "no" : "en";
      localStorage.setItem("jv-lang", next);
      return next;
    });
  }, []);

  // t accepts a bilingual object {en, no} or a plain string
  const t = useCallback(
    (value) => {
      if (value && typeof value === "object" && ("en" in value || "no" in value)) {
        return value[lang] ?? value.en;
      }
      return value;
    },
    [lang]
  );

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggle, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
};
